import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';
import {SessionService} from '../../../core/service/session.service';
import {EventService, NyuukaJisshiCondDto, NyuukaJisshiReqDto} from '../../../core/service/event.service';
import {MasterService} from '../../../core/service/master.service';
import {KEISHA_SHUBETSU, NYUUKA_SHUKKA_EDITABLE_LIMIT} from '../../constants';
import {NyuukaEvent} from '../../interfaces/nyuuka-event';
import {exceptKeyWithOptional, JisshiDateNonNullable, yyyyMMdd} from '../../typeAliases';
import {AbstractEventJisshiNaiyou} from '../../interfaces/abstract-event-jisshi-naiyou';
import cloneDeep from 'lodash-es/cloneDeep';
import {MailService} from '../../../core/service/mail.service';
import {WasuuErrorStateMatcher} from '../../../core/error-state/wasuu-error-state-matcher';

@Component({
  selector: 'app-nyuuka-event-dialog',
  templateUrl: './nyuuka-event-dialog.component.html',
  styleUrls: ['./nyuuka-event-dialog.component.scss',
    './../../layout/layout.component.scss']
})
export class NyuukaEventDialogComponent implements OnInit {
  selectedMeisai: NyuukaEvent;
  inputForm: exceptKeyWithOptional<AbstractEventJisshiNaiyou, 'jisshiDate'> = this.eventService.getInitialAbstractEventJisshiNaiyou();
  editEvent = false;
  keishaShubetsu = '';
  edukeDate: yyyyMMdd;
  latestEdukeDate: yyyyMMdd;
  nyuukaWasuu?: number;
  // 登録・取り消しの処理中フラグ(両操作を相互排他し、二度押しによる二重実行を防ぐ)
  isProcessing = false;
  NYUUKA_SHUKKA_EDITABLE_LIMIT = NYUUKA_SHUKKA_EDITABLE_LIMIT;
  todayString = this.commonService.getDateWithString();
  // 90日前から今日までの範囲指定可能
  registerLimitDate = this.commonService.genOffsetDateWithStandardDateString(
    this.todayString, -NYUUKA_SHUKKA_EDITABLE_LIMIT);

  constructor(@Inject(MAT_DIALOG_DATA) public data: NyuukaEvent[],
              public matDialogRef: MatDialogRef<NyuukaEventDialogComponent>,
              public commonService: CommonService,
              public sessionService: SessionService,
              public eventService: EventService,
              private masterService: MasterService,
              private mailService: MailService,
              public wasuuErrorStateMatcher: WasuuErrorStateMatcher,
              ) {
    this.selectedMeisai = this.data[0];
    this.edukeDate = this.selectedMeisai.taishouEdukeDate;
    this.latestEdukeDate = this.selectedMeisai.taishouEdukeDate;
    this.nyuukaWasuu = this.selectedMeisai.nyuukaWasuu ? this.selectedMeisai.nyuukaWasuu : undefined;
    // 実施日の初期値は予定日をセット。実施済の場合、後でイベントの実施日に変更される。
    this.inputForm.jisshiDate = this.selectedMeisai.yoteiDate;
  }

  /**
   *
   */
  ngOnInit(): void {
    this.eventService.setInputForm2(this.inputForm, this.selectedMeisai);
    this.eventService.updateJisshiNichirei2(this.inputForm, this.edukeDate);
    this.keishaShubetsu = this.commonService.getKeishaShubetsu(this.selectedMeisai.taishouKeisha, this.masterService.keishaMaster);
    console.log(this.inputForm);
  }

  /**
   * 入荷イベント登録
   */
  register() {
    if (this.isProcessing) { return; }
    // 保存用に明細をコピー。はじかれた場合、元の明細を使用するため。
    const saveMeisai = cloneDeep(this.selectedMeisai);
    this.eventService.inputForm2Event2(this.inputForm, saveMeisai);
    // this.selectedMeisai.taishouEdukeDateは入出荷イベントの中で再計算されるので、ここでは再計算しない。
    if (saveMeisai.jisshiDate && this.nyuukaWasuu) {
      saveMeisai.nyuukaWasuu = this.nyuukaWasuu;
      this.isProcessing = true;
      const reqDto: NyuukaJisshiCondDto<NyuukaJisshiReqDto&{ isUndo: false }>
        = {type: 'nyuuka', event: saveMeisai as JisshiDateNonNullable<NyuukaEvent>, isUndo: false, latestEdukeDate: this.latestEdukeDate};
      this.eventService.updateNyuushukkaEvent2(reqDto).then(async () => {
        await this.eventService.setMokuhyouTemperature(this.selectedMeisai);
        // 成功した場合のみ明細にコピーする。
        this.selectedMeisai = saveMeisai;
        // 成功した場合のみ true を返す
        this.commonService.onClick(this.matDialogRef, true);
      }).catch(() => undefined)
        .finally(() => this.isProcessing = false);
    }
  }

  /**
   * 入荷イベント取り消し
   */
  undo() {
    if (this.isProcessing) { return; }
    if (confirm('入荷を取り消しますか?')) {
      if (this.selectedMeisai.jisshiDate) {
        this.isProcessing = true;
        const reqDto: NyuukaJisshiCondDto<NyuukaJisshiReqDto&{ isUndo: true }>
          = {type: 'nyuuka', event: this.selectedMeisai as JisshiDateNonNullable<NyuukaEvent>, isUndo: true};
        this.eventService.updateNyuushukkaEvent2(reqDto).then(() => {
          // 開発者向け通知(取り消しが成功した場合のみ送信する。メール失敗は取り消し失敗として扱わない)
          const meilText = this.mailService.genMailTextForEventUndo(this.selectedMeisai);
          this.mailService.sendMailToDeveloper(meilText);
          // 成功した場合のみ true を返す
          this.commonService.onClick(this.matDialogRef, true);
        }).catch(() => undefined)
          .finally(() => this.isProcessing = false);
      }
    }
  }

  /**
   * 入荷イベント削除
   */
  delete() {
    if (confirm('作業を削除しますか?')) {
      this.eventService.deleteEvents([this.selectedMeisai]).then(() => {
        // 成功した場合のみ true を返す
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }
}
